import { Routes } from '@angular/router';
import { GiftCardCreatePageComponent } from './pages/gift-card-create-page/gift-card-create-page.component';

export const routes: Routes = [
  { path: '', redirectTo: 'create', pathMatch: 'full' },
  { path: 'create', component: GiftCardCreatePageComponent }
];
